<div>
    <h2  class="p-3 mb-0 roboto-medium" *ngIf="title">{{ title }}</h2>
    <button class="close-button" mat-icon-button [mat-dialog-close]="true">
        <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button>

</div>

<div class="p-4">
    <mat-dialog-content>
        <div class="dialog-heading mb-3">
            {{message}}
        </div>
        <div *ngIf="pdfLinks && (!errorExists || errorExists.length===0)">
            <div *ngFor="let pdf of pdfLinks">
                <a href="{{pdf.PDF_URL}}" target="_blank"> {{pdf.PDF_URL}} </a>
            </div>
        </div>

        <div *ngIf="(errorExists && errorExists.length!=0)">
            <div *ngFor="let error of errorExists">
                <p> {{error.ERROR_DESCRIPTION}} </p>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="text-right">
        <button mat-raised-button mat-dialog-close tabindex="-1">{{closeButtonText}}</button>
    </mat-dialog-actions>
</div>